// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1zz1E","modalFooterButton":"ModalNotes_modalFooterButton__3jU_y"};